// import { computed, onMounted, watch, nextTick } from 'vue'
// import type { SelectItem } from 'primevue/selectitem'
// import {
//   LISTING_TYPE_OPTIONS,
//   PROCESSING_STATUS_OPTIONS,
//   TRANSACTION_TYPE_OPTIONS,
//   REAL_ESTATE_CATEGORY_OPTIONS,
//   POSTER_TYPE,
//   DIRECTION_OPTIONS,
// } from '@/modules/realestate/constants/realestate.const'
// import { nl2br } from '@/lib/utils'

// type Select = {
//   label: string
//   value: string
// }

export const initialValues = {
  id: '',
  type: '',
  name: '',
  address: '',
  representative_name: '',
  phone: '',
  email: '',
  lat: '16.072180426953476',
  lng: '108.22161769866943',
  logo: '',
  description: '',
  working_hours: {
    start: null,
    end: null,
  },
}

// "{\"start\":\"2025-03-13T01:00:00.386Z\",\"end\":\"2025-03-13T10:00:00.435Z\"}"
const getWorkingHours = (time: string) => {
  let times = {
    start: null,
    end: null,
  }
  try {
    times = JSON.parse(time)
  } catch (error) {
    console.error('Error parsing working hours:', error)
  }

  return times
}


export const mappingValuesToForm = (values: any) => {
  return {
    id: values.id || '',
    type: values.type || '',
    name: values.name || '',
    address: values.address || '',
    representative_name: values.representative_name || '',
    phone: values.phone || '',
    email: values.email || '',
    lat: values.wgs84_coordinates?.coordinates?.[1] || '16.072180426953476', // Default to Da Nang coordinates
    lng: values.wgs84_coordinates?.coordinates?.[0] || '108.22161769866943', // Default to Da Nang coordinates
    logo: values.logo || null,
    description: values.description || null,
    working_hours: getWorkingHours(values.working_hours) || '',
  }
}

export const formatDataToSubmit = (values: any) => {
  return {
    type: values.type || '',
    name: values.name || '',
    address: values.address || '',
    representative_name: values.representative_name || '',
    phone: values.phone || '',
    email: values.email || '',
    lat: values.lat || '16.072180426953476',
    lng: values.lng || '108.22161769866943',
    logo: values.logo?.uuid || '',
    description: values.description || '',
    working_hours: values.working_hours?.start && values.working_hours?.end ? JSON.stringify({
      start: values.working_hours.start ? new Date(values.working_hours.start).toISOString() : null,
      end: values.working_hours.end ? new Date(values.working_hours.end).toISOString() : null,
    }) : '',
  }
}
